import { COLORS } from './colors';

export const GRID_GAP = 4;

export const charToFill = (char: string): string => {
  if (char === 'W') return COLORS.WHITE;
  if (char === 'B') return COLORS.BLACK;
  return COLORS.BLUE;
};

export function generateTileSVG(pattern: string, width: number): string {
  const CENTER = `${width / 2},${width / 2}`;
  const COORDS = [
    `0,${width / 2}`,
    `0,0`,
    `${width / 2},0`,
    `${width},0`,
    `${width},${width / 2}`,
    `${width},${width}`,
    `${width / 2},${width}`,
    `0,${width}`,
  ];

  let polygonsStr = '';
  let currentIndex = 0;
  let startChar = pattern[0];

  while (currentIndex < pattern.length) {
    const points = [COORDS[currentIndex % 8], COORDS[(currentIndex + 1) % 8]];
    let nextDiffIndex = currentIndex + 1;
    while (nextDiffIndex < pattern.length && pattern[nextDiffIndex] === startChar) {
      nextDiffIndex++;
      points.push(COORDS[nextDiffIndex % 8]);
    }

    points.push(CENTER);
    polygonsStr += `<polygon points="${points.join(' ')}" fill="${charToFill(startChar)}" stroke="none"/>`;

    currentIndex = nextDiffIndex;
    startChar = pattern[currentIndex];
  }

  if (pattern[0] === pattern[pattern.length - 1]) {
    polygonsStr += `<polygon points="${COORDS[1]} ${CENTER} ${COORDS[7]}" fill="${charToFill(pattern[0])}" stroke="none"/>`;
  }

  return `
    <svg width="${width}" height="${width}" xmlns="http://www.w3.org/2000/svg" shape-rendering="crispEdges">
      ${polygonsStr}
    </svg>
  `;
}
